import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../lib/api/client';
import { useAuth } from '../../contexts/AuthContext';
import type { User } from '@lov/shared';

export function useMe() {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      const response = await apiClient.get<User>('/auth/me');
      return response.data;
    },
    enabled: isAuthenticated,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
